/* eslint-disable no-unused-vars */


import { Node, mergeAttributes } from "@tiptap/core";

import katex from "katex";


export const MathInline = Node.create({
    name: "mathInline",
    group: "inline",
    inline: true,
    atom: true,
  
    addAttributes() {
      return {
        latex: { default: "" }
      };
    },
  
    parseHTML() {
      return [{ tag: "span[data-math-inline]" }];
    },
  
    renderHTML({ node, HTMLAttributes }) {
      return [
        "span",
        mergeAttributes(HTMLAttributes, { "data-math-inline": "" }),
        node.attrs.latex
      ];
    },
  
    addNodeView() {
      return ({ node, getPos, editor }) => {
        const dom = document.createElement("span");
        dom.className = "math-inline-node";
        dom.style.cssText = "cursor: pointer; display: inline-block; padding: 2px 6px; border-radius: 4px; margin: 0 2px; transition: all 0.2s;";
        
        try {
          katex.render(node.attrs.latex, dom, {
            throwOnError: false,
            displayMode: false
          });
        } catch (e) {
          dom.textContent = node.attrs.latex;
        }
  
        dom.onmouseenter = () => {
          dom.style.background = "#cce5ff";
          dom.style.borderColor = "#80bdff";
        };
        dom.onmouseleave = () => {
          dom.style.background = "transparent";
          dom.style.borderColor = "transparent";
        };
  
        dom.onclick = (e) => {
          e.preventDefault();
          const pos = getPos();
          if (typeof pos === "number") {
            const event = new CustomEvent("editMath", {
              detail: { pos, latex: node.attrs.latex }
            });
            document.dispatchEvent(event);
          }
        };
  
        return { dom };
      };
    }
  });


// Page Break Node
export const PageBreak = Node.create({
    name: "pageBreak",
    group: "block",
    atom: true,
  
    parseHTML() {
      return [{ tag: "div[data-page-break]" }];
    },
  
    renderHTML({ HTMLAttributes }) {
      return ["div", mergeAttributes(HTMLAttributes, { "data-page-break": "true" }), ""];
    },
  
    addNodeView() {
      return () => {
        const dom = document.createElement("div");
        dom.className = "page-break-node";
        dom.setAttribute("data-page-break", "true");
        dom.innerHTML = '<div class="page-break-line"><span>Page Break</span></div>';
        return { dom };
      };
    }
  });


// Answer Box Node (visual input field)
  export const AnswerBox = Node.create({
    name: "answerBox",
    group: "inline",
    inline: true,
    atom: true,
  
    parseHTML() {
      return [{ tag: "span[data-answer-box]" }];
    },
  
    renderHTML({ HTMLAttributes }) {
      return ["span", mergeAttributes(HTMLAttributes, { "data-answer-box": "true" }), ""];
    },
  
    addNodeView() {
      return () => {
        const dom = document.createElement("span");
        dom.className = "answer-box-node";
        dom.setAttribute("data-answer-box", "true");
        dom.contentEditable = "false";
        return { dom };
      };
    }
  });
  